import { Divider, Box, Grid, Typography, TextField as MuiTextField } from '@mui/material'
import PlanSettingsForm from './components/PlanSettingsForm'

interface Props {
  planSettings: PdfPlanSettings
  onPlanSettingsChange: (planSettings: PdfPlanSettings) => void
  setPlanDate: (date: string) => void
  planDate: string
}

const ExportSettingsForm = ({
  planSettings,
  onPlanSettingsChange,
  setPlanDate,
  planDate,
}: Props) => {
  return (
    <>
      <Divider>Einstellungen</Divider>

      <PlanSettingsForm
        planSettings={planSettings}
        onPlanSettingsChange={onPlanSettingsChange}
        formId="export-plans-settings-form"
      />

      <Box mb={1} mt={2}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={6}>
            <Box ml={2}>
              <Typography fontWeight={'fontWeightMedium'}>Datum für Pläne</Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <MuiTextField
              name="plan-date-text-input"
              rows={1}
              data-cy="plan-date-text-input"
              placeholder="TT.MM.YYYY"
              onChange={e => setPlanDate(e.target.value)}
              value={planDate}
              size="small"
              fullWidth
            />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default ExportSettingsForm
